import { BlankState } from '@domain-group/suit-theme'

import blankImageUrl from '@components/ListBlankState/assets/filterBlankState.svg'

type ProcessingFeesBlankStateProps = {
  debtorType?: 'Agency' | 'Brand' | 'Provider',
  hasRequiredFilters: boolean,
}

const ProcessingFeesBlankState = (props: ProcessingFeesBlankStateProps) => {
  const { debtorType, hasRequiredFilters } = props

  const debtorTypeText = debtorType === 'Brand' ? `${debtorType} and ` : ''

  return (
    <BlankState boxProps={{ marginBottom: ['large', 0] }} imageUrl={blankImageUrl}>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Title>
        {hasRequiredFilters ? 'No Results Available' : 'Filters Not Selected'}
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Title>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>
        {hasRequiredFilters
          ? 'No Results Available. Please try adjusting your filters or add a Processing Fee above.'
          : debtorTypeText.concat('Service/Service Product must be selected.')}
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Paragraph>
    </BlankState>
  )
}

export default ProcessingFeesBlankState
